import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const EXPERIMENT_I18N_NAMESPACE =
  '@mc/next/experiments/pen-7570_v1_global_sticky_footer_all_classes_top_line'

export const i18nInstance = registerI18nResources({
  namespace: EXPERIMENT_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
